import axios from 'axios';

export const APK_AUTH_TOKEN_KEY = 'apk_auth_token';

const LOGIN_URL =
  'https://prod.univision.solutions/login-manager/api/v1/auth/signin-apk';

const APK_LIST_URL =
  'https://prod.univision.solutions/org-manager/api/v1/org/active-apk/list';

const apkClient = axios.create({
  headers: {'Content-Type': 'application/json'},
});

apkClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(APK_AUTH_TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const apkLogin = (username, password) =>
  axios.post(LOGIN_URL, {username, password});

export const fetchActiveApkList = () => apkClient.get(APK_LIST_URL);
